import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { ChecklistProgressBarComponent } from './checklist-progress-bar/checklist-progress-bar.component';

import { ChecklistItemComponent } from './checklist-item/checklist-item.component';
import { ChecklistInputComponent } from './checklist-input/checklist-input.component';
import { NgxTolgeeModule } from '@tolgee/ngx';

@Component({
	selector: 'au-checklist',
	templateUrl: './au-checklist.component.html',
	styleUrls: ['./au-checklist.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [
		MatIcon,
		ChecklistProgressBarComponent,
		ChecklistItemComponent,
		ChecklistInputComponent,
		NgxTolgeeModule,
	],
})
export class AuChecklistComponent implements OnInit {
	// TODO this is for demo purpose, create types and use it as an Input later
	@Input() checklistData: any = [
		{
			text: 'Fire alarms',
			checked: true,
		},
		{
			text: 'Emergency lighting',
			checked: false,
		},
		{
			text: 'Fire extinguishers',
			checked: false,
		},
		{
			text: 'Fire doors',
			checked: false,
		},
		{
			text: 'Carbon Monoxide Detectors',
			checked: true,
		},
		{
			text: 'Sprinkler systems',
			checked: true,
		},
		{
			text: 'Dry and wet risers',
			checked: true,
		},
		{
			text: 'Obstructions',
			checked: false,
		},
	];

	constructor() {}

	// eslint-disable-next-line @angular-eslint/no-empty-lifecycle-method
	ngOnInit(): void {}

	addChecklist(): void {
		// TODO Here goes logic for importing checklist or whatever
	}

	// TODO Add typing later
	addNewChecklistItem(checklistItem: any): void {
		this.checklistData.push(checklistItem);
	}

	get completedAmount(): number {
		let count = 0;

		this.checklistData.forEach(item => {
			if (item.checked) {
				count++;
			}
		});

		return count;
	}

	get completedPercentage(): number {
		// completed amount divided by total amount in rounded percentage
		return Math.round((this.completedAmount / this.checklistData.length) * 100);
	}
}
